import { ToastContentProps } from 'react-toastify';
import { UnapprovedComposition } from '../models/model';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

type Props = Partial<ToastContentProps> & {
  unapprovedCompositions: UnapprovedComposition[];
  message: string;
};

const UnapprovedCompositionToastMsg = ({ unapprovedCompositions, message }: Props) => {
  const { t } = useTranslation();
  const uniqueCompositions = _.uniqBy(unapprovedCompositions, 'composition_cd');
  return (
    <div className="custom-toast">
      <b>{message}</b>
      <br></br>
      {uniqueCompositions.map((composition, index) => (
        <div key={index}>
          {t('PartsConfigurationDetail.dialog.composition_cd')}
          {composition.composition_cd}
          <span>&nbsp;&nbsp;</span>
          {t('PartsConfigurationDetail.dialog.composition_name')}
          {composition.composition_name}
        </div>
      ))}
    </div>
  );
};

export default UnapprovedCompositionToastMsg;
